<template>
  <MainWithDetailLayout
    :main-route-name="mainRoutetName"
    :is-main-full-width="!isDetailScreen"
  >
    <VerticalContainer>
      <div class="shipments-wrapper">
        <ShipmentsSearch
          class="shipments-search-wrapper"
        />
        <ShipmentsTable :selected-id="$route.params.id" />
      </div>
      <template
        v-if="isShipmentsDemo"
        #buttons
      >
        <Button
          :on-click="displayShipmentsMap"
          text="Map"
        />
      </template>
    </VerticalContainer>
  </MainWithDetailLayout>
</template>
<script>
import MainWithDetailLayout from '../../components/organisms/layout/main-with-detail-layout';
import VerticalContainer from '../../components/organisms/layout/vertical-container';
import ShipmentsTable from '../../components/organisms/shipments/shipments-table';
import ShipmentsSearch from '../../components/organisms/shipments/shipments-search';
import Button from '../../components/atoms/button/button';

import { routeNames } from '../../constants';

export default {
  name: 'ShipmentsList',
  components: {
    MainWithDetailLayout,
    VerticalContainer,
    ShipmentsTable,
    ShipmentsSearch,
    Button,
  },
  computed: {
    mainRoutetName() { return routeNames.shipments.list; },
    isDetailScreen() { return this.$route.name !== routeNames.shipments.list; },
    isLoading() { return this.$store.state.shipments.isLoadingShipments; },
    hasShipments() { return this.$store.getters['shipments/hasShipments']; },
    isShipmentsDemo() { return this.$root.workspaceFeatures.shipmentsDemo; },
  },
  watch: {
    selectedTeamId() {
      if (!this.hasShipments) {
        this.loadData();
      }
    },
  },
  created() {
    // Redirect to home if shipments is disabled
    if (!this.isShipmentsDemo
     && !this.$root.workspaceFeatures.shipmentScreens) {
      this.$router.push({ name: routeNames.home });
      return;
    }
    if (!this.hasShipments) {
      this.loadData();
    }
  },
  methods: {
    loadData() {
      this.$store.dispatch('shipments/getShipments');
    },
    displayShipmentsMap() {
      this.$router.push({ name: routeNames.shipments.map }).catch(() => { });
    },
  },
};
</script>
<style lang="scss" scoped>
.shipments-wrapper {
  height: 100%;
}
.shipments-search-wrapper {
  margin-bottom: 15px
}
</style>
